import { render, staticRenderFns } from "./indexLeft01.vue?vue&type=template&id=86049eb6&scoped=true&"
import script from "./indexLeft01.vue?vue&type=script&lang=js&"
export * from "./indexLeft01.vue?vue&type=script&lang=js&"
import style0 from "./indexLeft01.vue?vue&type=style&index=0&id=86049eb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86049eb6",
  null
  
)

export default component.exports